import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { CustomerTopNav } from "./CustomerTopNav";
import { CustomerBottomNav } from "./CustomerBottomNav";

/**
 * Responsive shell for /customer/* routes.
 *
 *   < md  : full-width, top-aligned content, fixed BOTTOM nav, 72px bottom pad.
 *   >= md : sticky TOP nav, max-width content (each page picks its own width).
 *
 * The 440px phone container is gone. Each page is responsible for its own
 * `max-w-*` constraint on desktop so layouts can vary (max-w-md for QR,
 * max-w-2xl for Profile, max-w-7xl + 60/40 grid for Dashboard, etc.).
 *
 * Tab transitions: a 200ms opacity fade keyed by pathname keeps tab swaps
 * from feeling like instant cuts. Scroll-to-top on every route change so
 * each page enters at the brand mark, not mid-list.
 */
export const CustomerLayout = () => {
  const location = useLocation();
  const mainRef = useRef(null);

  useEffect(() => {
    if (mainRef.current) mainRef.current.scrollTop = 0;
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-napoli-cream flex flex-col">
      <CustomerTopNav />
      <main
        ref={mainRef}
        data-testid="customer-page"
        className="relative flex-1 pb-[88px] md:pb-12"
      >
        <div
          key={location.pathname}
          className="animate-in fade-in duration-200"
          data-testid="customer-page-content"
        >
          <Outlet />
        </div>
      </main>
      <CustomerBottomNav />
    </div>
  );
};

export default CustomerLayout;
